// src/utils/urlToUrlSourceMap.ts
import UrlTypes from '@/enums/UrlTypes';
import UrlSourceTypes from '@/enums/UrlSourceTypes';

/**
 * Complete mapping of every UrlTypes value
 * into the UrlSourceTypes bucket where its HTML should live.
 */
export const urlToUrlSourceMap: Record<UrlTypes, UrlSourceTypes> = {
    [UrlTypes.CATEGORY_HUB]: UrlSourceTypes.CATEGORY_HUB,
    [UrlTypes.CATEGORY]: UrlSourceTypes.CATEGORY,
    [UrlTypes.CATEGORY_DESCRIPTION]: UrlSourceTypes.CATEGORY,
    [UrlTypes.PRODUCT]: UrlSourceTypes.PRODUCT,
    [UrlTypes.PRODUCT_DESCRIPTION]: UrlSourceTypes.PRODUCT,
    [UrlTypes.PAGE]: UrlSourceTypes.PAGE,
    [UrlTypes.PAGE_DESCRIPTION]: UrlSourceTypes.PAGE,
    [UrlTypes.OTHER]: UrlSourceTypes.OTHER,
    // UNCLASSIFIED intentionally maps to OTHER because it represents URLs that do not fit into any specific category.
    [UrlTypes.UNCLASSIFIED]: UrlSourceTypes.OTHER,
};
